module.exports = __webpack_public_path__ + "static/media/uni.0eb4419f.svg";